"use strict";exports.isBoolean=function(o){return"boolean"==typeof o};
//# sourceMappingURL=isBoolean.cjs.map
